import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { STUDY_PLAN_METRICS_TRANSLATION_KEY } from "./constants";
export default {
  es: /*#__PURE__*/_defineProperty({}, STUDY_PLAN_METRICS_TRANSLATION_KEY, {
    CREATE_STUDY_PLAN: 'Crear plan de estudios',
    EDIT_STUDY_PLAN_SHORT: 'Crear plan',
    // Activity
    ACTIVITY_TITLE: 'Objetivo semanal',
    MINUTE_COUNT: '{{progress}}/{{total}} min',
    ACTIVITY_EMPTY_LABEL: '¡Buen inicio de semana! Es hora de ir a clases',
    ACTIVITY_EMPTY_3_DAYS_LABEL: 'Aún no has visto clases esta semana, ¡empieza hoy!',
    ACTIVITY_IN_PROGRESS_LABEL: 'Vas a buen ritmo, ¡sigue aprendiendo así!',
    ACTIVITY_ALMOST_COMPLETED_LABEL: 'Estás muy cerca de tu objetivo semanal, ¡sigue así!',
    ACTIVITY_COMPLETED_LABEL: '¡Buen trabajo! Completaste tu objetivo semanal',
    ACTIVITY_EXCEDED_LABEL: '¡Increíble trabajo! Superaste tu objetivo semanal',
    WEEKLY_TARGET: 'Tu objetivo semanal es de {{minutes}} minutos',
    CHANGE_WEEKLY_TARGET: 'Si tu objetivo semanal de {{minutes}} minutos no está funcionando, puedes modificarlo ',
    CHANGE_WEEKLY_TARGET_CTA: 'aquí',
    // Progress
    PROGRESS_TITLE: 'Tu progreso esta semana',
    // Empty view
    EMPTY_VIEW_TITLE: 'Aún no inicias tu proceso de aprendizaje',
    EMPTY_VIEW_DESC: 'Descubre contenido según tus intereses',
    EMPTY_VIEW_BUTTON: 'Ver contenido para ti',
    // Error
    STUDY_PLAN_ERROR: 'Ocurrió un error al obtener la información de tu progreso.',
    STUDY_PLAN_ERROR_DESCRIPTION: 'Parece que ocurrió un problema y no pudimos realizar esta acción. Te recomendamos que lo vuelvas a intentar.',
    STUDY_PLAN_RETRY_BUTTON_LABEL: 'Volver a cargar',
    LEARNING_PLAN_COMPLETED_COURSES: 'Cursos obligatorios',
    LEARNING_PLAN_COMPLETED_COURSES_TOOLTIP: 'Total de cursos completados de tus cursos obligatorios asignados dentro de una ruta.',
    LEARNING_PLAN_COMPLETED_TRACKS: 'Rutas completadas',
    LEARNING_PLAN_COMPLETED_TRACKS_TOOLTIP: 'Total de rutas completadas de tus rutas obligatorias asignadas.',
    LEARNING_PLAN_COMPLETED_PROJECTS: 'Proyectos aprobados',
    LEARNING_PLAN_COMPLETED_PROJECTS_TOOLTIP: 'Total de proyectos finalizados de tus proyectos obligatorios asignados.',
    LEARNING_PLAN_COMPLETED_ADDITIONAL_COURSES: 'Cursos adicionales',
    LEARNING_PLAN_COMPLETED_ADDITIONAL_COURSES_TOOLTIP: 'El total de cursos completados de tus cursos asignados / inscritos fuera de una ruta.',
    LEARNING_PLAN_EDIT_STUDY_PLAN_TITLE: 'Aún no creas tu plan de estudios',
    LEARNING_PLAN_EDIT_STUDY_PLAN_DESC: 'Organiza tu semana para alcanzar tus objetivos de aprendizaje.',
    LEARNING_PLAN_ACTIONS_TITLE: 'Tu progreso hasta hoy',
    EDIT_STUDY_PLAN: 'Editar'
  })
};